import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["carMakeSelect", "modelYearSelect"]
  static values = {
    yearRangeUrl: String,
    selectYearText: { type: String, default: "Select year" },
    errorLoadingYearsText: { type: String, default: "Error loading years" }
  }

  connect() {
    const makeId = this.carMakeSelectTarget.value
    const tomSelect = this.modelYearSelectTarget.tomselect

    if (makeId) {
      this.updateModelYears({ target: this.carMakeSelectTarget })
    } else {
      this.resetTomSelect(tomSelect, this.selectYearTextValue, { enable: false, gray: true })
    }
  }

  async updateModelYears(event) {
    const makeId = event.target.value
    const selectEl = this.modelYearSelectTarget
    const tomSelect = selectEl.tomselect

    if (!makeId) {
      return this.resetTomSelect(tomSelect, this.selectYearTextValue, { enable: false, gray: true })
    }

    try {
      const url = this.yearRangeUrlValue.replace(":id", makeId)
      const response = await fetch(url)
      const { years = [] } = await response.json()

      const options = years
        .slice()
        .reverse()
        .map(year => ({ value: String(year), text: String(year) }))

      // Clear everything and add only the year options (no placeholder)
      tomSelect.clear()
      tomSelect.clearOptions()
      tomSelect.addOptions(options)

      // Reset text color to normal
      if (tomSelect.control_input) {
        tomSelect.control_input.style.color = ""
      }

      // Enable the select
      tomSelect.enable()

      const selectedYear = selectEl.dataset.selectedYear
      if (selectedYear && years.includes(Number(selectedYear))) {
        tomSelect.setValue(String(selectedYear))
      }
    } catch (error) {
      console.error("Error fetching year range:", error)
      this.resetTomSelect(tomSelect, this.errorLoadingYearsTextValue, { enable: false, gray: true })
    }
  }

  resetTomSelect(tomSelect, placeholder, { enable = true, gray = false } = {}) {
    const selectEl = this.modelYearSelectTarget
    const placeholderOption = { value: "", text: placeholder }

    if (tomSelect) {
      tomSelect.clear()
      tomSelect.clearOptions()
      tomSelect.addOption(placeholderOption)
      // Don't pre-select the empty option - just show the placeholder text
      tomSelect.setTextboxValue(placeholder)

      if (tomSelect.control_input) {
        tomSelect.control_input.style.color = gray ? "#9ca3af" : ""
      }

      tomSelect[enable ? "enable" : "disable"]()
    } else {
      selectEl.innerHTML = `<option value="">${placeholder}</option>`
      selectEl.disabled = !enable
    }
  }
}
